import { render, staticRenderFns } from "./expoList.vue?vue&type=template&id=5abef58c&scoped=true"
import script from "./expoList.vue?vue&type=script&lang=js"
export * from "./expoList.vue?vue&type=script&lang=js"
import style0 from "./expoList.vue?vue&type=style&index=0&id=5abef58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abef58c",
  null
  
)

export default component.exports